import { render, staticRenderFns } from "./NoFloorplan.vue?vue&type=template&id=cba48c60&scoped=true"
import script from "./NoFloorplan.vue?vue&type=script&setup=true&lang=ts"
export * from "./NoFloorplan.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./NoFloorplan.vue?vue&type=style&index=0&id=cba48c60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cba48c60",
  null
  
)

export default component.exports